var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#F9C126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 27.3925C27.2 30.4022 22.6595 27.6496 17.7916 27.6496C12.9237 27.6496 8 30.2885 8 27.2788C8 25.5626 9.56926 23.1758 11.8205 21.4423C13.5167 20.1359 15.5996 19.2002 17.6919 19.2002C19.8436 19.2002 21.9513 20.2131 23.6327 21.6036C25.7547 23.3569 27.2 25.7127 27.2 27.3925Z",
    fill: "#444053"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 21.6002C20.7464 21.1947 16.3088 20.7004 12 21.4391C13.6084 20.1345 15.5834 19.2002 17.5674 19.2002C19.6071 19.2002 21.6057 20.2117 23.2 21.6002Z",
    fill: "#F6F8FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2743 15.6163C11.6058 15.5955 13.1663 15.4642 14.1574 14.8325C14.3166 14.7278 14.4964 14.6686 14.6809 14.6602C14.996 14.6501 15.3586 14.7971 15.1265 15.6201C14.7504 16.9663 12.5665 18.481 11.2111 18.3971C9.90763 18.3163 8.36134 17.7293 7.34027 15.6655C7.24244 15.467 7.19426 15.2427 7.20078 15.0161C7.21264 14.5996 7.34818 14.0776 8.04791 14.6595C8.9933 15.4453 10.787 15.5942 11.1467 15.6163C11.1892 15.6189 11.2318 15.6189 11.2743 15.6163Z",
    fill: "#444053"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0741 15.6163C24.4056 15.5955 25.9661 15.4642 26.9572 14.8325C27.1164 14.7278 27.2962 14.6686 27.4807 14.6602C27.7959 14.6501 28.1584 14.7971 27.9263 15.6201C27.5502 16.9663 25.3663 18.481 24.0109 18.3971C22.7074 18.3163 21.1612 17.7293 20.1401 15.6655C20.0422 15.467 19.9941 15.2427 20.0006 15.0161C20.0124 14.5996 20.148 14.0776 20.8477 14.6595C21.7931 15.4453 23.5868 15.5942 23.9465 15.6163C23.989 15.6189 24.0316 15.6189 24.0741 15.6163Z",
    fill: "#444053"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.0971d2ba6abd60790aefb1d80637ad63.svg";
export { ForwardRef as ReactComponent };